<template>
    <v-lazy-image
      v-if="src && !failedToLoad"
      class="icon icon_filled"
      :src="src"
      :width="size"
      :height="size"
      :class="{
          icon_loading: !isLoaded
      }"
      :intersection-options="{rootMargin: '500px'}"
      :style="{
        width: size,
        height: size
      }"
      @error="failedToLoad = true"
      @load="isLoaded = true"
    />
    <div
      v-else
      class="icon"
      :style="{
        width: size,
        height: size
      }"
    ></div>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2';

export default {
  props: {
    src: String,
    size: {
      type: String,
      default: '80px',
    },
  },
  components: {
    VLazyImage,
  },
  data() {
    return {
      isLoaded: false,
      failedToLoad: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.icon {
    object-fit: cover;
    object-position: center;
    border-radius: 22.5%;
    mask: url(../assets/ios-mask.svg) center/100% 100% no-repeat;

    &_loading {
        opacity: 0;
    }

    &:not(&_filled) {
        background-color: var(--stub-bg);
    }
}
</style>
